import React from 'react'

export const CateringIcon = (): JSX.Element => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3203 4C11.3203 3.21875 11.737 2.47656 12.5703 1.77344C13.4297 1.04427 14.4062 0.679688 15.5 0.679688V17.3203H13.4297V10.6797H11.3203V4ZM7.17969 6.5V0.679688H8.82031V6.5C8.82031 7.38542 8.52083 8.15365 7.92188 8.80469C7.32292 9.42969 6.58073 9.76823 5.69531 9.82031V17.3203H3.625V9.82031C2.73958 9.76823 1.9974 9.42969 1.39844 8.80469C0.799479 8.15365 0.5 7.38542 0.5 6.5V0.679688H2.17969V6.5H3.82031V0.679688H5.5V6.5H7.17969Z"
      fill="black"
    />
  </svg>
)
